module.exports = __webpack_public_path__ + "static/media/xls.85c2738d.svg";